module.exports = __webpack_public_path__ + "images/Envelope_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Envelope_hover.png
// module id = 386
// module chunks = 0 1